import React from "react";
const SvgPencil = props => (
  <svg viewBox="0 0 22 21" {...props}>
    <g
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6.4 18l-3.3-3.4L17.2.4l3.4 3.4z" />
      <path d="M1.4 19.6l5-1.7-3.3-3.3-1.7 5M14.7 2.9l3.4 3.4" />
    </g>
  </svg>
);
export default SvgPencil;
